import { InitFeatureParams } from '@/features/types'
import { getRoutes } from './routes'

export const initUserCourseTask = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
